export default __webpack_public_path__ + "static/whatsapp-icon-88e6a2380e3ead764ae890e89a79f261.png";